import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  dividerStyle: { height: 1 },
  flRegionsStyles: { backgroundColor: colors.neutral.cotton },
  txtRegionsStlyles: { marginLeft: 12, marginVertical: 9 },
});
export default styles;
